<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h4>Detalhar Conta Empresa</h4>
			<form *ngIf="planoContaEmpresa">
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>

						<div class="form-group field col-12 md:col-4">
							<label>Descrição da Conta</label>
							<label class="form-control">{{ planoContaEmpresa.descricao }}</label>
						</div>

						<div class="form-group field col-12 md:col-8">
							<label>Especificação</label>
							<label class="form-control">{{ planoContaEmpresa.especificacao }}</label>
						</div>

						<div class="form-group field col-12 md:col-4">
							<label>DRE</label>
							<label class="form-control">{{ planoContaEmpresa.dre }}</label>
						</div>

						<div class="form-group field col-12 md:col-6">
							<label>Grupo</label>
							<label class="form-control">{{ planoContaEmpresa.planoContaGrupo?.descricao }}</label>
						</div>
						<div class="form-group field col-12 md:col-2">
							<label>Código</label>
							<label class="form-control">{{ planoContaEmpresa.codigo }}</label>
						</div>
						<div class="form-group field col-12 md:col-2">
							<label>Configurável</label>
							<label class="form-control">{{ planoContaEmpresa.configuravel === true ? 'SIM' : 'NÃO' }}</label>
						</div>
						<div class="form-group field col-12 md:col-2">
							<label>Status</label>
							<label class="form-control">{{ planoContaEmpresa.ativo ? 'ATIVO' : 'INATIVO' }}</label>
						</div>
					</div>
					<div class="p-fluid p-formgrid grid justify-content-end">
						<div class="field col-12 md:col-3">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-primary mt-5" (click)="voltar()"></button>
						</div>
					</div>
				</div>
			</form>

		</div>
	</div>
</div>